<template>
  <div
    class="elevation-2 scroll-y v-row"
    :style="{ width: width + 'px', zIndex: 1, height: '100%', position: 'relative' }"
  >
    <!-- botão float:right para selecionar vars -->
    <v-btn
      :style="{ position: 'absolute', right: '8px', top: '8px' }"
      icon
      @click.stop="$emit('click:vars')"
      class="mx-0"
    >
      <v-icon>mdi-eye</v-icon>
    </v-btn>

    <!-- itens da sidebar -->
    <div class="v-row pa-2 children-pa-2">
      <OCapCont label="Organização">
        <router-link :to="`/orgs/${org.id}`" v-html="org.label" />
      </OCapCont>

      <OCapCont label="Módulo / Veículo">
        <router-link :to="`/clients/${vehicle.clientId}`">
          {{ vehicle.clientId }}
        </router-link>
        :: {{ vehicle.code }} (id: {{ firstTrip.vehicleId }})
      </OCapCont>

      <OCapCont label="Motorista">
        {{ driver.name }} (id: {{ firstTrip.driverId }})
      </OCapCont>

      <OCapCont v-if="firstTrip.serial != null" label="Crachá">
        <code>{{ firstTrip.serial }}</code>
      </OCapCont>

      <OCapCont label="Status">
        <span class="tag green" v-if="firstTrip.isValid">VALID</span>
        <span class="tag red" v-else>INVALID</span>
        /
        <span class="tag info" v-if="firstTrip.isOngoing">ONGOING</span>
        <span class="tag grey" v-else>CLOSED</span>
      </OCapCont>

      <OCapCont label="Início/Fim">
        <span>{{ firstTrip.startTimestamp | moment }}</span>
        até <br />
        <span>{{ firstTrip.endTimestamp | moment }}</span>
      </OCapCont>

      <OCapCont label="Criado">
        {{ firstTrip.createdAt | moment }}
      </OCapCont>

      <OCapCont label="Duração (Delta)">
        {{ firstTrip.durationS | sDuration }}
      </OCapCont>

      <OCapCont label="LapseCount">
        {{ firstTrip.lapseCount }}
        ({{ firstTrip.lapseCount | sDuration }})
      </OCapCont>

      <OCapCont label="Distância (footer)">
        {{ firstTrip.distanceM | mDistance }} km
      </OCapCont>

      <OCapCont label="IncOdos">
        {{ firstTrip.incOdos }}
        ({{ (firstTrip.incOdos * 100) | mDistance }} km)
      </OCapCont>

      <div v-if="firstTrip.errorMessage != null">
        <v-alert icon="warning" outlined color="error">
          {{ firstTrip.errorMessage }}
        </v-alert>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    width: { type: Number, required: true },
    tripData: { required: true }
  },
  computed: {
    org() {
      return this.tripData.org || {}
    },
    firstTrip() {
      return this.tripData.mainTrip
    },
    vehicle() {
      return this.firstTrip.vehicle
    },
    driver() {
      return this.firstTrip.driver
    }
  }
}
</script>

<style></style>
